import MergeStudiesModal from './MergeStudiesModal';

export default MergeStudiesModal;
